import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class FormService {

  constructor(private http: HttpClient) {
  }

  sendReq(obj) {
    return this.http.post('https://fsetan.ru/api/calc/', obj);
  }
}
